import { Component, OnChanges, Input } from '@angular/core';
import { Observation } from '../Models/Observation';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { asepticProcedures, fiveMomentsMap } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-asepticprocedures.service';
import { TranslationKeys } from 'ph-bhp-localization';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { AppConfig } from 'src/app/app.config';
import { PHBHPFeaturePackageObserveObservationService } from '../ph-bhp-feature-package-observe-observation.service';

@Component({
  selector: 'lib-ph-bhp-observe-protocol-observationList',
  templateUrl: './ph-bhp-observe-protocol-observationList.component.html',
  styleUrls: ['./ph-bhp-observe-protocol-observationList.component.css']
})
export class PhBhpObserveProtocolObservationListComponent implements OnChanges {
  @Input() observations: Array<any>;
  asepticprocedures: Array<any> = asepticProcedures;
  fiveMomentsMap = fiveMomentsMap;
  translationKeys: typeof TranslationKeys = TranslationKeys;
  isEditing: boolean = false;
  tagComments: any = [];
  backupObservations: any = [];
  observationComments: any = [];
  predefinedComments: any = [];

  constructor(
    private observeService: PHBHPFeaturePackageObserveObservationService,
    private evaluationService: PHBHPFeaturePackageEvaluationService,
    public layoutService: PHBHPLayoutPackageService,
    public config: AppConfig) { }

  async ngOnInit() { }

  async ngOnChanges() {
    var userData = this.config.userData;
    var institutionGroupId = await this.evaluationService.getInstitutionGroupIdById(this.layoutService.institutionID).toPromise();
    if (institutionGroupId != 0) {
      institutionGroupId = `${institutionGroupId},${this.layoutService.institutionID}`;
    }

    this.predefinedComments = await this.evaluationService.getPredefinedCommentsForObservation(userData.country, institutionGroupId, this.layoutService.institutionID).toPromise();
    this.predefinedComments = this.predefinedComments.filter(res => res.packages?.includes("2"));
    for (let i = 0; i < this.predefinedComments.length; i++) {
      var predefinedComment = this.predefinedComments[i];
      switch (predefinedComment.commentName) {
        case 'jewellery / wrist watch':
          predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH');
          break;
        case 'artificial finger nails / nail varnish':
          predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH');
          break;
        case 'Hand disinfection executed incorrectly':
          predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED');
          break;
        case 'Skin antisepsis executed incorrectly':
          predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED');
          break;
        case 'Process interrupted':
          predefinedComment.commentName = this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED');
          break;
      }
    }

    var predefinedCommentsText = this.predefinedComments.map(res => res.commentName);
    if (this.observations) {
      for (let i = 0; i < this.observations.length; i++) {
        var observationComments = this.observations[i].observeComments.split("##");
        this.observations[i].comment = observationComments.join(', ');
        this.observations[i].jewellery = false;
        this.observations[i].nails = false;
        this.observations[i].handDisinfection = false;
        this.observations[i].skinAntisepsis = false;
        this.observations[i].processInterrupted = false;
        var individualCommentsList = [];
        this.observations[i].individualComments = '';
        for (let j = 0; j < observationComments.length; j++) {
          var comment = observationComments[j];
          let key = this.layoutService.getTranslationKey(comment);
          switch (key) {
            case 'SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH':
              this.observations[i].jewellery = true;
              break;
            case 'SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH':
              this.observations[i].nails = true;
              break;
            case 'SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED':
              this.observations[i].handDisinfection = true;
              break;
            case 'SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED':
              this.observations[i].skinAntisepsis = true;
              break;
            case 'SOP_OBSERVATION.PROCESS_INTERRUPTED':
              this.observations[i].processInterrupted = true;
              break;
            default:
              if (predefinedCommentsText.includes(comment)) {
                this.observations[i][comment] = true;
              } else {
                individualCommentsList.push(comment);
              }
              break;
          }
        }

        this.observations[i].individualComments = individualCommentsList.join(', ');
      }
    }
  }

  asepticproceduresValue(observation: Observation) {
    if (observation.asepticActionId != 0)
      return this.asepticprocedures.find(res => res.id == observation.asepticActionId).value;
  }

  fiveMomentsUsingKeys(shortName, key) {
    if (shortName != 0)
      return this.fiveMomentsMap.find(res => this.layoutService.translateText(res[key]) == shortName);
    return null;
  }

  startEditingComments() {
    this.isEditing = true;
    this.backupObservations = this.observations;
  }

  getObserveComments(observation: Observation) {
    let comments = observation.observeComments.split("##");
    let final: string = "";
    comments.forEach((element) => {
      let comment = "";
      let key = this.layoutService.getTranslationKey(element);
      key = key ? comment = this.layoutService.translateText(key) : comment = element;;
      final = final + comment + ", ";
    });

    let result = final.slice(0, -2);
    return result;
  }

  isCommentSelected(predefinedComment, observation) {
    if (predefinedComment.predefinedCommentID == 1) return observation.jewellery;
    if (predefinedComment.predefinedCommentID == 2) return observation.nails;
    if (predefinedComment.predefinedCommentID == 3) return observation.handDisinfection;
    if (predefinedComment.predefinedCommentID == 4) return observation.skinAntisepsis;
    if (predefinedComment.predefinedCommentID == 5) return observation.processInterrupted;
    return observation[predefinedComment.commentName];
  }

  selectComment(predefinedComment, observation) {
    var observationIndex = this.observations.indexOf(observation);
    if (predefinedComment.predefinedCommentID == 1) this.observations[observationIndex].jewellery = !this.observations[observationIndex].jewellery;
    if (predefinedComment.predefinedCommentID == 2) this.observations[observationIndex].nails = !this.observations[observationIndex].nails;
    if (predefinedComment.predefinedCommentID == 3) this.observations[observationIndex].handDisinfection = !this.observations[observationIndex].handDisinfection;
    if (predefinedComment.predefinedCommentID == 4) this.observations[observationIndex].skinAntisepsis = !this.observations[observationIndex].skinAntisepsis;
    if (predefinedComment.predefinedCommentID == 5) this.observations[observationIndex].processInterrupted = !this.observations[observationIndex].processInterrupted;
    if (this.observations[observationIndex][predefinedComment.commentName]) {
      this.observations[observationIndex][predefinedComment.commentName] = !this.observations[observationIndex][predefinedComment.commentName];
    } else {
      this.observations[observationIndex][predefinedComment.commentName] = true;
    }
  }

  cancelEditingComments() {
    this.isEditing = false;
    this.observations = this.backupObservations;
    this.ngOnChanges();
  }

  saveEditingComments() {
    var editedObservations = [];
    for (let i = 0; i < this.observations.length; i++) {
      var observation = this.observations[i];
      var comments = [];
      if (observation.jewellery) comments.push(this.layoutService.translateText('SOP_OBSERVATION.JEWELLERY_OR_WRIST_WATCH'));
      if (observation.nails) comments.push(this.layoutService.translateText('SOP_OBSERVATION.ARTIFICIAL_NAILS_OR_VARNISH'));
      if (observation.handDisinfection) comments.push(this.layoutService.translateText('SOP_OBSERVATION.HAND_DISINFECTION_WRONG_EXECUTED'));
      if (observation.skinAntisepsis) comments.push(this.layoutService.translateText('SOP_OBSERVATION.SKIN_ANTISEPSIS_WRONG_EXECUTED'));
      if (observation.processInterrupted) comments.push(this.layoutService.translateText('SOP_OBSERVATION.PROCESS_INTERRUPTED'));
      var predefinedCommentsText = this.predefinedComments.filter(comment => comment.predefinedCommentID > 5).map(res => res.commentName);
      for (let j = 0; j < predefinedCommentsText.length; j++) {
        var predefinedComment = predefinedCommentsText[j];
        if (observation[predefinedComment]) comments.push(predefinedComment);
      }

      if (observation.individualComments.length > 0) comments.push(observation.individualComments);
      editedObservations.push({ observeObservationID: observation.observeObservationID, observeComments: comments.join('##') });
    }

    this.layoutService.showLoader = true;
    var userId = this.config.userData.userId;
    this.observeService.updateObservationComments(editedObservations, userId).subscribe((res: any) => {
      // this.layoutService.showSuccess(this.layoutService.translateText('SOP_OBSERVATION.COMMENTS_UPDATED_SUCCESSFULLY'));
      this.layoutService.showLoader = false;
      this.observations = res;
      this.backupObservations = this.observations;
      this.isEditing = false;
      this.ngOnChanges();
    });
  }
}
